import {
  PROFILELIST_START,
  PROFILELIST_SUCCESS,
  SCHEDULELIST_START,
  SCHEDULELIST_SUCCESS,
} from "../types/index";

const getProfileListSuccess = (profilelist) => {
  return {
    type: PROFILELIST_SUCCESS,
    profilelist: profilelist,
  };
};

const getProfileListStart = () => {
  return {
    type: PROFILELIST_START,
  };
};

const getScheduleListSuccess = (schedulelist) => {
  return {
    type: SCHEDULELIST_SUCCESS,
    schedulelist: schedulelist,
  };
};

const getScheduleListStart = () => {
  return {
    type: SCHEDULELIST_START,
  };
};

export {
  getProfileListSuccess,
  getProfileListStart,
  getScheduleListSuccess,
  getScheduleListStart,
};
